import axios, { CancelTokenSource } from "axios";

/**
 * Wrapper around axios to get a cancellation token,
 * easier for mocking in tests
 */
export const getCancelTokenSource = (): CancelTokenSource => {
	return axios.CancelToken.source();
};
